var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _linearGradient, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftFormsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#036c70",
    d: "M430 200v181.7c0 10.1-8.2 18.3-18.3 18.3H118.3c-10.1 0-18.3-8.2-18.3-18.3V200l170-20 160 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#37c6d0",
    d: "M118.3 0h293.4C421.8 0 430 8.2 430 18.3V200H100V18.3C100 8.2 108.2 0 118.3 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a9ba1",
    d: "M280 250h100v100H280z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 100,
    r: 60,
    fill: "#1a9ba1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 100,
    r: 30,
    fill: "#036c70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.7 80H100v250h121.7c10.1 0 18.3-8.2 18.3-18.3V98.3c0-10.1-8.2-18.3-18.3-18.3z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7 90H100v250h111.7c10.1 0 18.3-8.2 18.3-18.3V108.3c0-10.1-8.2-18.3-18.3-18.3z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7 90H100v230h111.7c10.1 0 18.3-8.2 18.3-18.3V108.3c0-10.1-8.2-18.3-18.3-18.3z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.7 90H100v230h101.7c10.1 0 18.3-8.2 18.3-18.3V108.3c0-10.1-8.2-18.3-18.3-18.3z",
    opacity: 0.2
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 38.2184,
    x2: 181.7816,
    y1: 326.3227,
    y2: 77.6773,
    gradientTransform: "matrix(1 0 0 -1 0 402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#058f92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#038489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026d71"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M18.3 90h183.3c10.1 0 18.3 8.2 18.3 18.3v183.3c0 10.1-8.2 18.3-18.3 18.3H18.3C8.2 310 0 301.8 0 291.7V108.3C0 98.2 8.2 90 18.3 90z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.1 159.8H95.5v32.5h48.1v19.3H95.5v48H72.2V140.4h75l-.1 19.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftFormsLogo);
export default __webpack_public_path__ + "static/media/MicrosoftFormsLogo.5a4802df1bb09f0fe0c3bff7536d48e3.svg";
export { ForwardRef as ReactComponent };